import { Theme } from '@mui/material';
import { hexToRGB } from 'src/utils';
import { customShadows } from 'src/theme';
import { customScrollbar } from 'src/theme/shared/scrollbar';

const notificationShared = (theme: Theme) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'row',
  position: 'absolute',
  maxWidth: 'calc(100% - 32px)',
  backgroundColor: 'grey.800',
  marginLeft: '16px',
  padding: 1,
  borderRadius: 1,
  boxShadow: customShadows.dark.z8 as string,
  zIndex: 1,
  ...customScrollbar(theme)
});

export const sxNotification = (theme: Theme) => ({
  ...notificationShared(theme),
  right: 16,
  top: 16,
  marginLeft: '16px',
});

export const scrollContainer = {
  display: 'flex',
  flexDirection: 'row',
  overflow: 'auto',
}

export const mdNotification = (theme: Theme) => ({
  ...notificationShared(theme),
  right: 24,
  top: 24,
  marginLeft: '24px',
});

export const sxNotificationText = ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  flex: 1,
  textWrap: 'nowrap'
});

export const sxNotificationAction = {
  display: 'flex',
  alignItems: 'center',
  ml: 1.5,
  mt: 1,
  alignSelf: 'flex-start',
};

export const sxIcon = (color: 'warning' | 'success') => (theme: Theme) => ({
  borderRadius: 48,
  mr: 1.5,
  minWidth: '48px',
  height: '48px',
  backgroundColor: hexToRGB(theme.palette[color].main, '0.16'),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'flex-start',
});
